import {
  DataTableSortableColumn,
  TooltipTrigger,
  TooltipContent,
  Typography,
  ColumnDef,
  Tooltip,
  Badge,
} from '@ui/components';
import { EmployeeAssignTableDataDto } from '@interfaces/models';
import { formatPhoneNumber } from '@helpers/utils';
import { Checkbox } from '@ui/components';
import { TFunction } from 'i18next';

export const getEmployeesAssignedColumns = (
  t: TFunction,
  isDefault: boolean,
): ColumnDef<EmployeeAssignTableDataDto>[] => [
  {
    id: 'select',
    size: 40,
    maxSize: 40,
    header: ({ table }) => (
      <Checkbox
        onCheckedChange={(value) => table.toggleAllRowsSelected(!!value)}
        checked={table.getIsAllRowsSelected()}
        disabled={isDefault}
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        checked={row.getIsSelected()}
        disabled={isDefault}
        className="ml-0.5"
      />
    ),
  },
  {
    accessorKey: 'firstName',
    header: ({ column }) => (
      <DataTableSortableColumn
        label={t('EMPLOYEE_PROFILES.EMPLOYEES_ASSIGN.NAME')}
        column={column}
      />
    ),
    cell: ({ row }) => (
      <Typography variant="labelMediumBook" element="span">
        {row.original.firstName}
      </Typography>
    ),
  },
  {
    accessorKey: 'lastName',
    header: ({ column }) => (
      <DataTableSortableColumn
        label={t('EMPLOYEE_PROFILES.EMPLOYEES_ASSIGN.LAST_NAME')}
        column={column}
      />
    ),
    cell: ({ row }) => (
      <Typography variant="labelMediumBook" element="span">
        {row.original.lastName}
      </Typography>
    ),
  },
  {
    accessorKey: 'phoneNumber',
    header: () => t('EMPLOYEE_PROFILES.EMPLOYEES_ASSIGN.PHONE_NUMBER'),
    cell: ({ row }) => (
      <Typography variant="labelMediumBook" element="span">
        {formatPhoneNumber(row.original.phoneNumber, row.original.phoneExt)}
      </Typography>
    ),
  },
  {
    accessorKey: 'label',
    size: 0,
    header: () => t('EMPLOYEE_PROFILES.EMPLOYEES_ASSIGN.DEPARTMENT'),
    cell: ({ row }) => {
      const labels = row.original.labels ?? [];
      const labelCount = labels.length;

      if (!labelCount) return '-';

      return (
        <div className="flex items-center gap-1 whitespace-nowrap">
          <Badge size="large" outlined>
            {labels[0]?.name}
          </Badge>
          {labelCount > 1 && (
            <Tooltip>
              <TooltipTrigger>
                <Badge size="large" outlined icon>
                  +{labelCount - 1}
                </Badge>
              </TooltipTrigger>
              <TooltipContent className="bg-background flex gap-2 w-auto max-w-[15rem] flex-wrap">
                {labels.map((label) => (
                  <Badge key={label.id} size="large" outlined>
                    {label.name}
                  </Badge>
                ))}
              </TooltipContent>
            </Tooltip>
          )}
        </div>
      );
    },
  },
];
